class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme.Cart = this;
    this.drawer = this.closest("drawer-component");
    window.FoxTheme.CartDrawer = this.drawer;
    this.openWhenAdded = this.dataset.openWhenAdded === "true";
  }

  connectedCallback() {
    window.FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (state) => {
        this.renderContents(state);
      }
    );
  }

  renderContents(parsedState, renderFooter = true) {
    // Keep empty-state class in sync — don't clear it when cart is actually empty.
    if (parsedState?.item_count === 0) {
      this.classList.add("is-empty");
    } else {
      this.classList.remove("is-empty");
    }

    const drawerRoot =
      this.closest("#Drawer-Cart") || document.getElementById("Drawer-Cart");

    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? (drawerRoot || document).querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState?.sections?.[section.id]) return;

      const html = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      if (html != null) sectionElement.innerHTML = html;
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer();
        document.body.classList.add("prevent-scroll");
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return null;
    const el = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
    ];

    if (renderFooter) {
      sections.push({
        id: "cart-drawer",
        selector: ".f-drawer__footer",
      });
    }

    return sections;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(
      document.querySelector("cart-drawer"),
      { overlay: document.querySelector("cart-drawer") }
    );
  }
  getSectionsToRender() {
    return [
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-drawer__footer",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
